module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-holder"
  }, [_c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "cover"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "datatable table"
  }, [_c('thead', [_c('tr', [(_vm.opt.checkboxes) ? _c('th', {
    staticClass: "header-column"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkboxAll),
      expression: "checkboxAll"
    }],
    attrs: {
      "type": "checkbox",
      "title": _vm.$t('datatable.toggleAll')
    },
    domProps: {
      "checked": Array.isArray(_vm.checkboxAll) ? _vm._i(_vm.checkboxAll, null) > -1 : (_vm.checkboxAll)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkboxAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkboxAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkboxAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkboxAll = $$c
        }
      }, _vm.checkAll]
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column) {
    return _c('th', {
      staticClass: "header-column",
      class: 'column-' + column.columnName
    }, [_c('div', {
      staticClass: "header-column-content"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.columnTitle(column))
      }
    }), _vm._v(" "), (_vm.opt.sortable && column.hideSort !== true) ? _c('b', {
      staticClass: "sort-icon",
      class: _vm.sortIconClasses(column),
      on: {
        "click": function($event) {
          return _vm.sort(column)
        }
      }
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 32 32",
        "xmlns": "http://www.w3.org/2000/svg",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "stroke-linejoin": "round",
        "stroke-miterlimit": "1.414"
      }
    }, [_c('path', {
      attrs: {
        "d": "M16 0l12.5 12.55h-25L16 0z",
        "fill": "#cccccc"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M16 31.966L3.5 19.414h25L16 31.966z",
        "fill": "#cccccc"
      }
    })])]) : _vm._e()])])
  })], 2), _vm._v(" "), (_vm.opt.filter) ? _c('tr', [(_vm.opt.checkboxes) ? _c('th', [_vm._v("\r\n           \r\n        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column) {
    return _c('th', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [(column.hideFilter !== true && column.filterType === 'input') ? _c('div', [_c('b-dropdown', {
      ref: ("dropdown-" + (column.columnName)),
      refInFor: true,
      attrs: {
        "id": ("dropdown-" + (column.columnName)),
        "block": "",
        "variant": "text"
      },
      scopedSlots: _vm._u([{
        key: "button-content",
        fn: function() {
          return [_c('b-form-input', {
            ref: "emailInput",
            refInFor: true,
            attrs: {
              "id": "input-1",
              "readonly": "",
              "type": "text",
              "placeholder": _vm.$t('datatable.filter') + ' ' + column.title
            },
            model: {
              value: (_vm.filterModel[column.columnName]),
              callback: function($$v) {
                _vm.$set(_vm.filterModel, column.columnName, $$v)
              },
              expression: "filterModel[column.columnName]"
            }
          })]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c('b-dropdown-form', {
      staticClass: "px-2",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.applyFilterInput(("dropdown-" + (column.columnName)))
        }
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "dropdown-form-email",
        "size": "sm"
      },
      model: {
        value: (_vm.filterModel[column.columnName]),
        callback: function($$v) {
          _vm.$set(_vm.filterModel, column.columnName, $$v)
        },
        expression: "filterModel[column.columnName]"
      }
    }), _vm._v(" "), _c('b-row', {
      staticClass: "mt-3 text-right",
      attrs: {
        "align-h": "end"
      }
    }, [_c('b-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('b-btn', {
      attrs: {
        "size": "sm",
        "variant": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.applyFilterInput(("dropdown-" + (column.columnName)))
        }
      }
    }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (column.hideFilter !== true && column.filterType === 'autocomplete-input') ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filterModel[column.columnName]),
        expression: "filterModel[column.columnName]"
      }, {
        name: "b-toggle",
        rawName: "v-b-toggle.sidebar-variant",
        modifiers: {
          "sidebar-variant": true
        }
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "align-self": "center",
        "type": "text",
        "placeholder": _vm.$t('datatable.filter') + ' ' + column.title
      },
      domProps: {
        "value": (_vm.filterModel[column.columnName])
      },
      on: {
        "keyup": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.sendFilterRequest()
        }, _vm.filter],
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filterModel, column.columnName, $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (column.hideFilter !== false && column.filterType === 'range') ? _c('div', [_c('b-input-group', {
      staticClass: "mb-1 range-input-filter"
    }, [_c('b-input-group-prepend', {
      staticClass: "p-1"
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filterModel[column.columnRange[0].value]),
        expression: "filterModel[column.columnRange[0].value]"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.filterModel[column.columnRange[0].value])
      },
      on: {
        "keyup": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.sendFilterRequest()
        }, _vm.filter],
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filterModel, column.columnRange[0].value, $event.target.value)
        }
      }
    })], 1), _vm._v(" "), _c('b-input-group', {
      staticClass: "range-input-filter"
    }, [_c('b-input-group-prepend', {
      staticClass: "p-1"
    }, [_vm._v("\r\n                  " + _vm._s(column.columnRange[1].text) + "\r\n                ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filterModel[column.columnRange[1].value]),
        expression: "filterModel[column.columnRange[1].value]"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.filterModel[column.columnRange[1].value])
      },
      on: {
        "keyup": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.sendFilterRequest()
        }, _vm.filter],
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filterModel, column.columnRange[1].value, $event.target.value)
        }
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), (column.hideFilter !== false && column.filterType === 'rangeMoney') ? _c('div', [_c('b-input-group', {
      staticClass: "mb-1 range-input-filter"
    }, [_c('b-input-group-prepend', {
      staticClass: "p-1"
    }, [_vm._v("\r\n                    " + _vm._s(column.columnRange[0].text) + "\r\n                ")]), _vm._v(" "), _c('money', _vm._b({
      staticClass: "form-control form-control-sm",
      nativeOn: {
        "keyup": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.sendFilterRequest()
        }, function($event) {
          return _vm.filter($event)
        }]
      },
      model: {
        value: (_vm.filterModel[column.columnRange[0].value]),
        callback: function($$v) {
          _vm.$set(_vm.filterModel, column.columnRange[0].value, $$v)
        },
        expression: "filterModel[column.columnRange[0].value]"
      }
    }, 'money', _vm.currency, false))], 1), _vm._v(" "), _c('b-input-group', {
      staticClass: "range-input-filter"
    }, [_c('b-input-group-prepend', {
      staticClass: "p-1"
    }, [_vm._v("\r\n                " + _vm._s(column.columnRange[1].text) + "\r\n              ")]), _vm._v(" "), _c('money', _vm._b({
      staticClass: "form-control form-control-sm",
      nativeOn: {
        "keyup": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.sendFilterRequest()
        }, function($event) {
          return _vm.filter($event)
        }]
      },
      model: {
        value: (_vm.filterModel[column.columnRange[1].value]),
        callback: function($$v) {
          _vm.$set(_vm.filterModel, column.columnRange[1].value, $$v)
        },
        expression: "filterModel[column.columnRange[1].value]"
      }
    }, 'money', _vm.currency, false))], 1)], 1) : _vm._e(), _vm._v(" "), (column.hideFilter !== false && column.filterType === 'date-range') ? _c('div', [_c('b-input-group', {
      staticClass: "mb-1 range-input-filter"
    }, [_c('b-input-group-prepend', {
      staticClass: "p-1"
    }, [_vm._v("\r\n                " + _vm._s(column.columnRange[0].text) + "\r\n              ")]), _vm._v(" "), _c('datepicker', {
      attrs: {
        "input-class": "table-datepicker",
        "language": _vm.dateLocale,
        "placeholder": _vm.dateFormat,
        "format": _vm.customFormatter,
        "inputFormat": _vm.inputFormat,
        "typeable": true,
        "clear-button": ""
      },
      on: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.sendFilterRequest()
        },
        "input": _vm.filter
      },
      model: {
        value: (_vm.filterModel[column.columnRange[0].value]),
        callback: function($$v) {
          _vm.$set(_vm.filterModel, column.columnRange[0].value, $$v)
        },
        expression: "filterModel[column.columnRange[0].value]"
      }
    })], 1), _vm._v(" "), _c('b-input-group', {
      staticClass: "range-input-filter"
    }, [_c('b-input-group-prepend', {
      staticClass: "p-1"
    }, [_vm._v("\r\n                " + _vm._s(column.columnRange[1].text) + "\r\n              ")]), _vm._v(" "), _c('datepicker', {
      attrs: {
        "input-class": "table-datepicker",
        "language": _vm.dateLocale,
        "placeholder": _vm.dateFormat,
        "format": _vm.customFormatter,
        "inputFormat": _vm.inputFormat,
        "typeable": true,
        "clear-button": ""
      },
      on: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.sendRequest()
        },
        "input": _vm.filter
      },
      model: {
        value: (_vm.filterModel[column.columnRange[1].value]),
        callback: function($$v) {
          _vm.$set(_vm.filterModel, column.columnRange[1].value, $$v)
        },
        expression: "filterModel[column.columnRange[1].value]"
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), (column.hideFilter !== true && column.filterType === 'select') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filterModel[column.columnName]),
        expression: "filterModel[column.columnName]"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "placeholder": _vm.$t('datatable.filter') + ' ' + column.title
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.filterModel, column.columnName, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.sendFilterRequest()
        }]
      }
    }, _vm._l((column.filterSelectOptions), function(option) {
      return _c('option', {
        domProps: {
          "value": option.value
        }
      }, [_vm._v("\r\n              " + _vm._s(option.key) + "\r\n            ")])
    }), 0) : _vm._e()])
  })], 2) : _vm._e()]), _vm._v(" "), _c('tbody', [(_vm.data.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "100%"
    }
  }, [_vm._v(_vm._s(_vm.$t('datatable.noData')))])]) : _vm._l((_vm.data), function(row) {
    return _c('tr', {
      class: {
        'invalid-row': _vm.isRowInvalid(row), 'invisible-row': _vm.isRowHidden(row), 'highlight-row': _vm.isRowHighlighted(row), 'alt-highlight-row': _vm.isRowAltHighlighted(row)
      }
    }, [(_vm.opt.checkboxes) ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checked[row[_vm.opt.checkboxValue]]),
        expression: "checked[row[opt.checkboxValue]]"
      }],
      staticClass: "chk",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": row[_vm.opt.checkboxValue],
        "checked": Array.isArray(_vm.checked[row[_vm.opt.checkboxValue]]) ? _vm._i(_vm.checked[row[_vm.opt.checkboxValue]], row[_vm.opt.checkboxValue]) > -1 : (_vm.checked[row[_vm.opt.checkboxValue]])
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.checked[row[_vm.opt.checkboxValue]],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row[_vm.opt.checkboxValue],
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.checked, row[_vm.opt.checkboxValue], $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.checked, row[_vm.opt.checkboxValue], $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.checked, row[_vm.opt.checkboxValue], $$c)
          }
        }, _vm.checkedSingle]
      }
    })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column) {
      return _c('td', {
        class: {
          'contents-highlight': column.highlight,
            'align-contents-right': column.align === 'right',
            'align-contents-center': column.align === 'center',
            'align-contents-left': column.align === 'left'
        },
        on: {
          "click": function($event) {
            return _vm.rowSelected(row)
          }
        }
      }, [(_vm.hasRowDetails) ? _c('b-link', {
        staticClass: "invisible-link",
        attrs: {
          "to": _vm.rowDetailsLink(row)
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(column.cell(row))
        }
      })]) : _c('span', {
        domProps: {
          "innerHTML": _vm._s(column.cell(row))
        }
      }), _vm._v(" "), (_vm.hasRowDetails) ? _c('b-link', {
        staticClass: "invisible-link",
        attrs: {
          "to": _vm.rowDetailsLink(row)
        }
      }, [_vm._t(column.columnName, null, {
        "row": row
      })], 2) : _vm._t(column.columnName, null, {
        "row": row
      })], 2)
    })], 2)
  })], 2), _vm._v(" "), (_vm.data.length > 0) ? _c('tfoot', {
    staticClass: "datatable-footer"
  }, [_c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.columns), function(column) {
    return _c('td', {
      class: {
        'align-contents-right': column.align === 'right', 'align-contents-center': column.align === 'center', 'align-contents-left': column.align === 'left'
      }
    }, [(column.showSummary) ? _c('label', {
      staticClass: "summary-label"
    }, [_vm._v(_vm._s(_vm.calculateSummary(column.columnName)))]) : _vm._e()])
  })], 2), _vm._v(" "), _c('tr', [(_vm.opt.checkboxes) ? _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkboxAll),
      expression: "checkboxAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkboxAll) ? _vm._i(_vm.checkboxAll, null) > -1 : (_vm.checkboxAll)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkboxAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkboxAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkboxAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkboxAll = $$c
        }
      }, _vm.checkAll]
    }
  })]) : _vm._e(), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "100%"
    }
  }, [_c('div', {
    staticClass: "table-footer split-3"
  }, [_c('div', [_vm._v("\r\n              " + _vm._s(_vm.paginationText) + "\r\n              "), (_vm.defaultOptions.partialCount && this.totalRows === 100) ? _c('b-img', {
    staticClass: "ml-2 generic-link",
    attrs: {
      "src": require("@/assets/images/sigma.svg"),
      "width": "15",
      "height": "15"
    },
    on: {
      "click": _vm.retrieveCount
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "size": "sm",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "per-page-field"
  }, [_c('label', {
    attrs: {
      "for": "perPageControl"
    }
  }, [_vm._v(_vm._s(_vm.$t('datatable.perPage')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perPage),
      expression: "perPage"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "id": "perPageControl"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.perPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changePerPage()
      }]
    }
  }, _vm._l((_vm.opt.per_page_options), function(perPageOption) {
    return _c('option', {
      domProps: {
        "value": perPageOption
      }
    }, [_vm._v(_vm._s(perPageOption) + "\r\n                  ")])
  }), 0)])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.generateReportVisible) ? _c('b-row', {
    staticClass: "mt-3 text-right",
    attrs: {
      "align-h": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.generateReportModal",
      modifiers: {
        "generateReportModal": true
      }
    }],
    attrs: {
      "variant": "primary",
      "disabled": _vm.load
    }
  }, [_vm._v("\r\n          " + _vm._s(_vm.$t('datatable.generateReport')) + "\r\n          "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('b-sidebar', {
    attrs: {
      "z-index": "1000",
      "id": "sidebar-variant",
      "title": "Sidebar",
      "bg-variant": "dark",
      "text-variant": "light",
      "shadow": ""
    }
  }, [_c('div', {
    staticClass: "px-3 py-2"
  }, [_c('p', [_vm._v("\r\n        Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis\r\n        in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.\r\n      ")]), _vm._v(" "), _c('b-img', {
    attrs: {
      "src": "https://picsum.photos/500/500/?image=54",
      "fluid": "",
      "thumbnail": ""
    }
  })], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "generateReportModal",
      "title": _vm.$t('datatable.generateReport'),
      "ok-title": _vm.$t('forms.apply'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.generateReport
    }
  }, [_vm._v("\r\n      " + _vm._s(_vm.$t('datatable.generateReportModalText')) + "\r\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5b31004","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./src/components/misc/datatable/datatable.html
// module id = 780
// module chunks = 1